import * as React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { useSiteMetadata } from '../hooks/useSiteMetadata';

export default function Seo({
  title,
  description,
  keywords,
  isBlogPost,
  lang,
  image,
  pathname,
}) {
  const { siteMetadata } = useSiteMetadata();

  const pageDescription = description || siteMetadata.description;

  return (
    <Helmet
      titleTemplate={siteMetadata?.title ? `%s | ${siteMetadata.title}` : `%s`}
    >
      {/* General tags */}
      <html lang={lang} />
      <title>{title}</title>
      <link rel="canonical" href={`${siteMetadata.siteUrl}${pathname}`} />
      <meta name="description" content={pageDescription} />
      <meta
        name="image"
        content={`${image || `${siteMetadata.siteUrl}/logo.png`}`}
      />
      {keywords?.length ? (
        <meta name="keywords" content={keywords.join(',')} />
      ) : null}

      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={pageDescription} />
      <meta
        property="og:image"
        content={`${image || `${siteMetadata.siteUrl}/logo.png`}`}
      />
      <meta property="og:url" content={`${siteMetadata.siteUrl}${pathname}`} />
      {isBlogPost ? (
        <meta property="og:type" content="article" />
      ) : (
        <meta property="og:type" content="website" />
      )}
      <meta property="og:site_name" content={siteMetadata.title} />

      {/* Twitter Card tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={siteMetadata.twitter} />
      <meta name="twitter:url" content={`${siteMetadata.siteUrl}${pathname}`} />
      <meta
        name="twitter:image"
        content={`${image || `${siteMetadata.siteUrl}/logo.png`}`}
      />
    </Helmet>
  );
}

Seo.defaultProps = {
  lang: `en`,
  keywords: [],
  isBlogPost: false,
};

Seo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  isBlogPost: PropTypes.bool,
  lang: PropTypes.string,
  image: PropTypes.string,
  pathname: PropTypes.string,
};
